<template>
  <div class="list">
    <ul>
      <li v-for="item in data" @click="toDetails(item.noticeId)">
        <div class="text">
          {{ item.noticeTitle }}
        </div>
        <div class="date">{{ handelDate(item.createTime) }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "List",
  props: {
    data: Array,
    type:String
  },
  methods: {
    handelDate(date) {
      return date.split(" ")[0];
    },
    toDetails(noticeId) {
      this.$router.push({
        path: "/newsDetails",
        query: { noticeId ,type:this.type}
      }); 
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  background-color: #fff;
  color: #000;
  font-size: 16px;
  padding: 35px 44px 0;
  li {
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &::before {
      content: "";
      display: block;
      position: absolute;
      width: 5px;
      height: 5px;
      background: #285bf9;
      border-radius: 5px;
      left: -2px;
      top: 9px;
    }
    padding-left: 15px;
    border-bottom: 1px dashed #ddd;
    padding-bottom: 15px;
    margin-bottom: 22px;

    .text {
      width: calc(100% - 120px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .date {
      color: #939393;
      width: 100px;
    }
  }
}
</style>
